<!------------------------------------------------------------------------------
 File: EntityManagers 
 Created by keni.
 with: IntelliJ IDEA
 Date: 16/04/2018
 Time: 15:18
------------------------------------------------------------------------------->
<template>
    <div>
        <div>
            <div class=" d-flex justify-content-start align-items-center ">

                <template v-if="is_entity_manager_only !== true">
                    <div v-if="edit_users!==true">
                        <div v-on:click="edit_users = true"
                             class="btn btn-primary btn-sm"
                        >
                            <i class="material-icons">add</i>
                        </div>
                    </div>
                </template>


                <!--show correct wording -->
                <h3 v-if="current_managers.length > 0">Assigned</h3>
                <h3 v-else>Assign managers</h3>
            </div>
            <!--display the currently assigned managers-->
            <div v-for="current_manager in current_managers">
                <div class="d-flex justify-content-between align-items-center">
                    <span>
                        {{current_manager.email}}
                    </span>
                    <span>
                        {{current_manager.first_name}} {{current_manager.last_name}}
                    </span>
                    <div class="btn btn-outline-secondary btn-sm"
                         :class="{
                            'disabled':isCurrentUser(current_manager) || is_entity_manager_only === true
                            }"
                         v-on:click="removeCurrentManager(current_manager)"
                    >
                        <i class="material-icons">delete</i>
                    </div>
                    <input type="hidden" name="entity_data->users_array[]" v-model="current_manager.id">
                </div>
            </div>
        </div>
        <div v-if="edit_users===true">
            <search-user
                    :table_laravel_route_uri="table_laravel_route_uri"
                    :search_user_uri="search_user_uri"
                    :options="options"
                    @selected_user_emit="selectedUsersEvent"
                    @close_search_event="SearchClosed"
            ></search-user>
        </div>
    </div>
</template>

<script>
    import {_} from 'underscore';

    export default {
        name: "EntityManagers",
        components: {},
        props: {
            is_entity_manager_only: {
                type: Boolean,
                default: null
            },
            table_laravel_route_uri: {
                type: String,
                default: null
            },
            search_user_uri: {
                type: String,
                default: null
            },
            managers_route_uri: {
                type: String,
                default: null
            },
            options: {
                type: Object,
                default: null
            },
            current_entity: {
                type: Number,
                default: null
            },
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            // load the predefined managers set
            this.allManagersList();
        },
        data() {
            return {
                edit_users: false,
                selected_users: [],
                current_managers: []
            }
        },
        methods: {
            isCurrentUser(user) {
                if (this.is_entity_manager_only === true) {
                    return true;
                }
                // console.log('isCurrentUser', 'x', $('body').data('user_id'),user);
                return $('body').data('user_id') === user.id
            },
            removeCurrentManager(user) {
                if (this.is_entity_manager_only === true) {
                    return
                }
                /**
                 * prevent the current user from deselecting as a manager
                 */
                if (!this.isCurrentUser(user)) {

                    this.current_managers = _.without(this.current_managers, _.findWhere(this.current_managers, {
                        id: user.id
                    }));
                }


            },
            selectedUsersEvent(obj) {
                console.log('obj', obj);
                this.selected_users = obj;
            },
            SearchClosed(closed) {
                console.log('search closed', closed);
                if (closed == true) {
                    this.edit_users = false;
                }
            },
            allManagersList() {
                let _this = this;

                if (typeof this.current_entity !== 'undefined' && this.current_entity !== null) {
                    if (this.current_entity !== '') {
                        // console.log('this.current_entity', this.current_entity);
                        let data = {
                            'entity_id': this.current_entity
                        };

                        axios.post(this.managers_route_uri, data)
                            .then(function (response) {
                                if (response.data.success) {
                                    // console.log('response.data.managers', response.data.managers);
                                    _this.current_managers = response.data.managers;
                                }
                            })
                            .catch(function () {

                            });
                    }
                }
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/entities/EntityManagers.vue?21f5aa04